import { render, staticRenderFns } from "./AdminStatusesColumn.vue?vue&type=template&id=39eb46ce&scoped=true"
import script from "./AdminStatusesColumn.vue?vue&type=script&lang=js"
export * from "./AdminStatusesColumn.vue?vue&type=script&lang=js"
import style0 from "./AdminStatusesColumn.vue?vue&type=style&index=0&id=39eb46ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39eb46ce",
  null
  
)

export default component.exports